"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultGTM = void 0;
const index_1 = require("../index");
const useSearchResultGTM = (initialQuery, totalResultCount, lastUserAction, isSubsequentRef, gtmPageName) => {
    (0, index_1.useSearchResultGTMQuery)(initialQuery, totalResultCount, lastUserAction, isSubsequentRef);
    (0, index_1.useSearchResultGTMTab)(lastUserAction, gtmPageName);
    (0, index_1.useSearchResultGTMFilter)(lastUserAction, gtmPageName);
};
exports.useSearchResultGTM = useSearchResultGTM;
